// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".pf-draft-approval{display:flex;flex-wrap:wrap;align-items:center;justify-content:space-between;gap:var(--space-static-s-bwcdfm, 12px)}.pf-draft-approval p{margin-bottom:0}.pf-draft-approval-actions{display:flex;flex-wrap:wrap;gap:var(--space-static-xs-789l1l, 8px)}", ""]);
// Exports
module.exports = exports;
